module.exports = __webpack_public_path__ + "img/snow.5bd4c137.svg";